import React from 'react';
import { Clock, MapPin, Phone, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const AboutSection = () => {
  const { t } = useLanguage();

  const openingHours = [
    { day: t('monday'), time: t('monThu') },
    { day: t('friday'), time: t('friTime') },
    { day: t('saturday'), time: t('satTime') },
    { day: t('sunday'), time: t('sunTime') }
  ];

  return (
    <section id="about" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* About Text */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="px-4 py-2 bg-red-600/20 text-red-500 text-xs font-bold tracking-widest rounded-full border border-red-600/30">
                {t('established')}
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              {t('aboutTitle')}
            </h2>
            
            <div className="h-1 w-20 bg-red-500"></div>
            
            <p className="text-gray-300 text-lg leading-relaxed">
              {t('aboutText')}
            </p>
          </div>

          {/* Opening Hours Card */}
          <div className="bg-gradient-to-br from-red-950/30 to-black border border-red-900/30 rounded-lg p-8 backdrop-blur-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-red-600/20 flex items-center justify-center">
                <Clock className="w-6 h-6 text-red-500" />
              </div>
              <h3 className="text-2xl font-bold text-white">{t('openingHoursTitle')}</h3>
            </div>
            
            <div className="space-y-4">
              {openingHours.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center py-3 border-b border-white/10 last:border-0"
                >
                  <span className="text-gray-300 font-medium">{item.day}</span>
                  <span className="text-white font-bold">{item.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;